<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card border">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Data Voucher</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'voucher'}">Data Voucher</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <form v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group mt-3 col-md-6">
                                            <label for="exampleFormControlSelect1">Kategori</label>
                                            <select class="form-select" v-model="form.category"
                                                :class="{ 'is-invalid': submitted && $v.form.category.$error }">
                                                <option value="">Pilih Kategori Voucher</option>
                                                <option value="tryout">Tryout</option>
                                                <option value="cpns">Paket CPNS</option>
                                                <option value="kedinasan">Paket Kedinasan</option>
                                                <option value="pppk">Paket PPPK</option>
                                                <option value="olimpiade">Paket Olimpiade</option>
                                                <option value="esai">Paket Esai</option>
                                                <option value="lkti">Paket LKTI</option>
                                            </select>
                                            <div v-if="submitted && !$v.form.category.required" class="invalid-feedback">Kategori Wajib diisi!</div>    
                                        </div>

                                        <div class="form-group mt-3 col-md-6">
                                            <label>Kode</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.code" :class="{ 'is-invalid': submitted && $v.form.code.$error }">
                                            <div v-if="submitted && !$v.form.code.required" class="invalid-feedback">Kode Wajib diisi!</div>    
                                        </div>

                                        <div class="form-group mt-3 col-md-6">
                                            <label for="exampleFormControlSelect1">Tipe</label>
                                            <select class="form-select" v-model="form.type"
                                                :class="{ 'is-invalid': submitted && $v.form.type.$error }">
                                                <option value="">Pilih Tipe Voucher</option>
                                                <option value="nominal">Nominal</option>
                                                <option value="percentage">Persentase</option>
                                            </select>
                                            <div v-if="submitted && !$v.form.type.required" class="invalid-feedback">Tipe Voucher Wajib diisi!</div>    
                                        </div>


                                        <div class="form-group mt-3 col-md-6">
                                            <label>Nominal</label>
                                            <input type="number" class="form-control"
                                                placeholder="Masukan data..." v-model="form.nominal" :class="{ 'is-invalid': submitted && $v.form.nominal.$error }">
                                            <div v-if="submitted && !$v.form.nominal.required" class="invalid-feedback">Nominal Wajib diisi!</div>    
                                        </div>

                                        <div class="form-group mt-3 col-md-6">
                                            <label for="exampleFormControlSelect1">Berlaku</label>
                                            <select class="form-select" v-model="form.apply">
                                                <option value="once">Sekali Pakai</option>
                                                <option value="repeated">Berulang</option>
                                            </select>
                                        </div>

                                        <div class="form-group mt-3 col-md-6">
                                            <label>Kuota</label>
                                            <input type="number" class="form-control" min="1"
                                                placeholder="Masukan data..." v-model="form.quota" :class="{ 'is-invalid': submitted && $v.form.quota.$error }">
                                            <div v-if="submitted && !$v.form.quota.required" class="invalid-feedback">Kuota Wajib diisi!</div>    
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Berlaku Hingga</label>
                                            <input type="date" class="form-control"
                                                placeholder="Masukan data..." v-model="form.expired_at" :class="{ 'is-invalid': submitted && $v.form.expired_at.$error }">
                                            <div v-if="submitted && !$v.form.expired_at.required" class="invalid-feedback">Berlaku hingga Wajib diisi!</div>    
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</button>
                                        <router-link :to="{name : 'voucher'}" class="btn btn-outline-primary">Kembali</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required
    } from "vuelidate/lib/validators";
    
    export default {
        name: 'voucher',
        metaInfo: {
            title: 'Form Voucher',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        created() {
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                label           : 'Tambah',
                form : {
                    id          : "",
                    code        : "",
                    category    : "",
                    type        : "",
                    nominal     : "",
                    apply       : "once",
                    quota       : 1,
                    expired_at  : ""
                },
                submitted       : false,
                waiting         : false
            }
        },
        validations: {
            form: {
                code: {
                    required
                },
                category: {
                    required
                },
                type: {
                    required
                },
                nominal: {
                    required
                },
                quota: {
                    required
                },
                expired_at: {
                    required
                }
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('code', this.form.code);
                    formData.append('category', this.form.category);
                    formData.append('type', this.form.type);
                    formData.append('nominal', this.form.nominal);
                    formData.append('apply', this.form.apply);
                    formData.append('quota', this.form.quota);
                    formData.append('expired_at', this.form.expired_at);

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/voucher/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'voucher' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Ubah";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/voucher/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id            = getResponse.id;
                            this.form.code          = getResponse.code;
                            this.form.category      = getResponse.category;
                            this.form.type          = getResponse.type;
                            this.form.nominal       = getResponse.nominal;
                            this.form.expired_at    = getResponse.expired_at;
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'voucher' });
                                }
                            });
                        }
                    });
                }
            }
        }
    }
</script>